import React from "react";

import { Modal, Typography } from "@packages/ds";
import { useIntl } from "react-intl";

import Button, { ButtonWrapper } from "ds/Button";
import Input from "ds/Input";
import useSelectorWithUrlParams from "Hooks/useSelectorWithUrlParams";
import { environmentDeletedErrorsSelector } from "Reducers/environment";

import * as S from "./DeleteEnvModal.style";

import type { Project } from "@packages/client";

interface Props {
  confirmDeleteModal: boolean;
  closeModal: () => void;
  environmentName: string;
  projectName?: string;
  confirmEnvironmentName: string;
  setConfirmEnvironmentName: (e) => void;
  allowDelete: boolean;
  toggleEnvironmentDelete: () => void;
  project?: Project;
}

export const DeleteEnvModal = ({
  confirmDeleteModal,
  closeModal,
  environmentName,
  projectName,
  confirmEnvironmentName,
  setConfirmEnvironmentName,
  allowDelete,
  toggleEnvironmentDelete
}: Props) => {
  const intl = useIntl();
  const error = useSelectorWithUrlParams(environmentDeletedErrorsSelector);

  const onDeleteButtonClick = () => {
    toggleEnvironmentDelete();
    closeModal();
  };
  return (
    <Modal
      isOpen={confirmDeleteModal}
      onOpenChange={closeModal}
      handleClose={closeModal}
      size="medium"
    >
      <Typography.Title tag="h2">
        {intl.formatMessage({ id: "delete_environment" })}
      </Typography.Title>
      <Typography.BodyText>
        <span>
          {intl.formatMessage(
            {
              id: "delete_confirm_text"
            },
            {
              environmentName: <strong>{environmentName}</strong>,
              projectName: <strong>{projectName}</strong>
            }
          )}
        </span>
      </Typography.BodyText>

      <S.AgreeWrapper>
        <Input
          analyticId="env_name_delete"
          autoComplete="off"
          id="confirm-input"
          label={intl.formatMessage({
            id: "env_name_delete"
          })}
          placeholder={intl.formatMessage({
            id: "env_name_delete.placeholder"
          })}
          required
          value={confirmEnvironmentName}
          onChange={event => setConfirmEnvironmentName(event.target.value)}
          width="264px"
        />
      </S.AgreeWrapper>
      {!!error && <>{String(error)}</>}
      <ButtonWrapper justifyContent="end">
        <Button variant="secondary" analyticId="cancel" onClick={closeModal}>
          {intl.formatMessage({
            id: "cancel"
          })}
        </Button>
        <S.DeactivateButton
          analyticId="delete_confirm_button"
          disabled={!allowDelete}
          onClick={onDeleteButtonClick}
        >
          {intl.formatMessage({
            id: "delete_confirm_button"
          })}
        </S.DeactivateButton>
      </ButtonWrapper>
    </Modal>
  );
};
